import { select } from 'd3-selection';
import throttle from 'lodash.throttle';

export const nearestDate = (dates, target) => {
  if (!target) target = Date.now();
  else if (target instanceof Date) target = target.getTime();

  let nearest = Infinity;
  let winner = -1;

  dates.forEach((date, i) => {
    if (date instanceof Date) date = date.getTime();
    const distance = Math.abs(date - target);
    if (distance < nearest) {
      nearest = distance;
      winner = i;
    }
  });

  return winner;
};

export const pluckDataFromX = ({ x, trends, xScale, extents }) => {
  const o = {};

  if (xScale) {
    const rawDate = xScale.invert(x);
    for (const key of Object.keys(trends)) {
      o[key] = null;
      const trend = trends[key];
      const extent = extents[key];
      const ni = nearestDate(
        trend.map((d) => d[0]),
        rawDate
      );
      const val = trend[ni][1];

      if (rawDate >= extent[0] && rawDate <= extent[1]) {
        o[key] = val;
      } else {
        o[key] = null;
      }
    }
  }
  return o;
};

export const spaceLabels = throttle(({ els, pollData, yScale }) => {
  const boxes = els.nodes().map((e) => {
    const party = e.dataset.party;
    const dummy = yScale(pollData[party]);
    select(e).attr('transform', `translate(0, ${dummy})`);
    const y = e.getCTM().f + e.getBBox().y;
    const height = e.getBBox().height;
    return { y, height, e, party };
  });

  const resolveLabels = (boxes) => {
    els.each((d, i, nodes) => {
      const el = select(nodes[i]);
      const party = el.attr('data-party');

      const box = boxes.find((d) => party === d.party);

      el.attr('transform', `translate(0, ${box.y})`);
      // el.select('text').text(boxes[i].y)
    });
  };

  const resolveOverlaps = (boxes, i = 0) => {
    if (i >= boxes.length - 1) {
      resolveLabels(boxes);
      return;
    }

    const a = boxes[i];
    const b = boxes[i + 1];

    const aBottom = a.y + a.height;
    const bTop = b.y;

    if (bTop <= aBottom) {
      b.y = aBottom + 2;
      resolveOverlaps(boxes, i + 1);
    } else {
      resolveOverlaps(boxes, i + 1);
    }
  };

  boxes.sort((a, b) => a.y - b.y);
  resolveOverlaps(boxes);
}, 0);

export const numberToOrdinal = (number) => {
  switch (number) {
    case 1:
      return 'first';
    case 2:
      return 'second';
    case 3:
      return 'third';
    case 4:
      return 'fourth';
    case 5:
      return 'fifth';
    case 6:
      return 'sixth';
    case 7:
      return 'seventh';
    case 8:
      return 'eighth';
    case 9:
      return 'ninth';
    case 10:
      return 'tenth';
    default:
      return '';
  }
};
